<template>
  <div>
    <b-table-simple bordered>
      <b-thead>
        <b-tr>
          <b-th v-for="(th, key) in tableHead" :key="key">{{th}}</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr v-for="(tr, rowIndex) in tableBody" :key="rowIndex">
          <PivotCell v-for="(item, colIndex) in tr" :key="colIndex" :item="item" />
        </b-tr>
      </b-tbody>
    </b-table-simple>
    <paginate
      v-if="pagesCount > 1"
      :page-count="pagesCount"
      :value="currentPage"
      container-class="pagination b-pagination"
      page-class="page-item"
      page-link-class="page-link"
      prev-class="page-item"
      prev-link-class="page-link"
      next-class="page-item"
      next-link-class="page-link"
      prev-text="«"
      next-text="»"
      :click-handler="pageClickHandler"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { groupBy } from 'lodash'
import {
  queryResultToTable,
  getTableColumns,
} from './helpers/query-result-to-table'
import paginate from 'paginate-array'
// components
import PivotCell from './PivotCell'

export default {
  props: {
    data: {
      type: Array,
      default: [],
    },
  },
  components: {
    PivotCell,
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 500,
      pagesCount: 0,
    }
  },
  computed: {
    tableHead() {
      return getTableColumns(this.data)
    },
    tableBody() {
      const { tbody } = queryResultToTable(this.data)

      this.pagesCount = Math.ceil(tbody.length / this.itemsPerPage)

      return paginate(tbody, this.currentPage, this.itemsPerPage).data
    },
  },
  methods: {
    pageClickHandler(currentPage) {
      this.currentPage = currentPage || 1
    },
  },
}
</script>

<style scoped>
.table th {
  font-weight: 500;
  cursor: pointer;
}

.table td {
  cursor: pointer;
}

.table tr:last-child td,
.table tr td:last-child {
  font-weight: 700;
}

.CellWithComment {
  position: relative;
}

.CellComment {
  display: none;
  position: absolute;
  z-index: 100;
  border: 1px;
  background-color: white;
  border-style: solid;
  border-width: 1px;
  border-color: #494d50;
  padding: 3px;
  color: #494d50;
  top: 35px;
  left: -15px;
}

.CellWithComment:hover span.CellComment {
  display: block;
}
</style>